import gql from 'graphql-tag';

export default gql`
  mutation updateShop(
    $id: Int!
    $name: String!
    $ttPhone: String
    $ttHours: String
    $ttAllDays: Int
    $type: String!
    $place_id: Int
    $category_id: Int
    $details: [ShopDetailInput]
    $blocks: JSON
    $is_new: Boolean
    $is_heart: Boolean
  ) {
    updateShop(
      id: $id
      name: $name
      ttPhone: $ttPhone
      ttHours: $ttHours
      ttAllDays: $ttAllDays
      type: $type
      place_id: $place_id
      category_id: $category_id
      details: $details
      blocks: $blocks
      is_new: $is_new
      is_heart: $is_heart
    ) {
      id
      name
      type
      place {
        id
        name
      }
      ttPhone
      ttHours
      ttAllDays
      category {
        id
      }
      details {
        title
      }
      is_new
      is_heart
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/graphql/shop/update.js